import { useSelector } from 'react-redux';
import { INTERACTION_ORIGIN } from '@constants/tracking';
import { RECENTS_ITEMS_PARAMETERS } from '@common/MyLists/constants';
import { ReactOnRailsRootComponent } from '@common/ReactOnRails';
import { RecentsProducts } from '../components/RecentsProducts';
import { RecentsProductsSimple } from '../components/RecentsProductsSimple';

interface RecentsProps {
    isSimpleList: boolean;
    maxProducts: number;
    isRightSticky: boolean;
    pageSize: number;
    className: string;
}

function Recents({
    isSimpleList,
    maxProducts = 6,
    isRightSticky = false,
    pageSize,
    className,
}: RecentsProps) {
    const recents = useSelector((state: any) => state.recents);
    const products = recents?.products;
    const RecentsComponent = isSimpleList ? RecentsProductsSimple : RecentsProducts;

    return (
        <RecentsComponent
            className={className}
            interactionOrigin={INTERACTION_ORIGIN.recent}
            isRightSticky={isRightSticky}
            itemsParameters={RECENTS_ITEMS_PARAMETERS}
            maxProducts={Number(maxProducts)}
            pageSize={pageSize}
            products={products}
        />
    );
}

export const RecentsStandalone = ReactOnRailsRootComponent(Recents, { withReduxStore: true });

export default Recents;
